export const environment = {
  envName: 'HML',
  production: true,
  firebase: {
    apiKey: "AIzaSyADtNj_n0IhXyxhAzqPp-tQChRoETwrdco",
    authDomain: "celcoin-prd.firebaseapp.com",
    projectId: "celcoin-prd",
    storageBucket: "celcoin-prd.appspot.com",
    messagingSenderId: "940968013662",
    appId: "1:940968013662:web:38c22caa5763bbbdcd69cf"
  },

  tenants: [
    {
      tenant: "capital-f8nv1",
      name: "capital",
      primaryColor: "#5749C2",
      overPrimary: "#000000",
      icon: "https://storage.googleapis.com/celcoin-prd.appspot.com/tenant-assets/capital/icon",
      apiKey: "eyJhbGciOiJFUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJEaWxldHRhIFNvbHV0aW9ucyIsImlhdCI6MTc1MjU4MzY5NzU3MSwiYXVkIjoiY2VsY29pbi1wcmQiLCJzdWIiOiJjYXBpdGFsIiwianRpIjoiZTNjNDI3ZmMtMzM0My00MTI5LTg2ZjItYzdmM2ZjZmNkZDllIiwidGVuYW50SWQiOiJjYXBpdGFsLWY4bnYxIn0.inNGQjehHtcjTqoJ1jhXFRiCZJEIvR0AgN5MJPL0hY-8UF0nz_18YhWfIswpvmHcIa0ktX185bW0GLhJFFU3bQ",
      client: "matera",
      clientSuite: true,
      infoHeader: false,
      biz: false,
      apiUrl: 'https://api.capital.dilettapay.app',
      formattedName: "Capital Empreendedor",
      logo: "https://storage.googleapis.com/celcoin-prd.appspot.com/tenant-assets/capital/logo",
      logoLogin: "https://storage.googleapis.com/celcoin-prd.appspot.com/tenant-assets/capital/logo-login",
      minimalLogin: false
    }
  ],
  apiUrl: 'https://api.capital.dilettapay.app',
  apiUrlFunctions: 'https://us-central1-celcoin-prd.cloudfunctions.net',
  keyEncryptAuth: 'oGTy7QtyHr48GE6re5KTckkGnbm6oo7SwRHsi2gqjapqflY9hjTAJ4GyUtt9YrSK',
  account: '413453',
  branch: '3100',
  wallet: '109',
  bank: '341',
  currency: '9'
}